// extracted by mini-css-extract-plugin
export default {"verticalMenu":"Menu_verticalMenu__GII3J","menuHeader":"Menu_menuHeader__Q2fQs","menuLink":"Menu_menuLink__TdM3o","menuIcon":"Menu_menuIcon__nSQi1"};